var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhyus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 441.542,
    height: 423.421,
    viewBox: "0 0 441.542 423.421",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "whyus",
    transform: "translate(-29.229 -40.683)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2823",
    "data-name": "Group 2823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2797",
    "data-name": "Group 2797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2796",
    "data-name": "Group 2796"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2795",
    "data-name": "Group 2795"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2794",
    "data-name": "Group 2794"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1669",
    "data-name": "Path 1669",
    d: "M278.438,462.058C261.2,453.9,254.327,434.5,251.9,416.434c-.406-3.016-1.27-6.122-.289-8.994s4.006-5.234,6.9-4.424c2.4.671,3.814,3.1,5.422,5.029a17.789,17.789,0,0,0,8.17,5.528c2.077.668,4.542.874,6.251-.484,2.346-1.865,2.046-5.49,1.523-8.47q-1.464-8.331-2.925-16.659a28.169,28.169,0,0,1-.6-9.011c.449-2.988,2.054-5.965,4.756-7.239s6.489-.233,7.582,2.585a27.915,27.915,0,0,1,.713,3.7c.292,1.224,1.1,2.5,2.335,2.642,1.25.149,2.3-.9,3.044-1.923,2.57-3.532,4-7.765,5.3-11.953s2.526-8.459,4.764-12.216,5.661-7.014,9.891-7.979,9.229.9,11.017,4.913.063,8.7-2.031,12.559A67.525,67.525,0,0,1,312.1,379.6a5.562,5.562,0,0,0-1.9,2.886c-.311,2.1,1.907,3.754,3.981,4.075,2.348.365,4.722-.274,7.094-.394s5.065.48,6.316,2.529c1.738,2.842-.271,6.469-2.426,8.986a57.846,57.846,0,0,1-15.231,12.6c-2.058,1.174-4.248,2.269-5.757,4.11s-2.123,4.7-.7,6.622,4.282,2.131,6.509,1.315,4.071-2.41,6.122-3.607c3.837-2.24,9.178-2.853,12.4.245a9.573,9.573,0,0,1,2.416,8.177,22.067,22.067,0,0,1-3.274,8.136,58.163,58.163,0,0,1-21.577,21.352c-8.95,4.906-17.61,7.289-27.644,5.431",
    fill: "#f5f5f5"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2802",
    "data-name": "Group 2802"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2801",
    "data-name": "Group 2801"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2800",
    "data-name": "Group 2800"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2799",
    "data-name": "Group 2799"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2798",
    "data-name": "Group 2798"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1670",
    "data-name": "Path 1670",
    d: "M281.17,450.011a271.277,271.277,0,0,1,5.741-30.569q.971-4.018,1.917-7.935c.635-2.6,1.264-5.185,2.036-7.672a135.627,135.627,0,0,1,5.254-14.036c1.887-4.384,3.838-8.475,5.689-12.287s3.662-7.328,5.441-10.464a107.328,107.328,0,0,1,9.485-14.162c1.246-1.578,2.253-2.771,2.946-3.57.335-.38.6-.679.794-.9a2.364,2.364,0,0,1,.285-.295,2.156,2.156,0,0,1-.241.333l-.752.939c-.665.823-1.644,2.037-2.863,3.633a113.628,113.628,0,0,0-9.312,14.224c-1.752,3.14-3.529,6.66-5.368,10.473s-3.765,7.91-5.635,12.288a137.1,137.1,0,0,0-5.2,13.993c-.764,2.474-1.385,5.033-2.02,7.643l-1.913,7.932a277.852,277.852,0,0,0-5.774,30.5",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2807",
    "data-name": "Group 2807"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2806",
    "data-name": "Group 2806"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2805",
    "data-name": "Group 2805"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2804",
    "data-name": "Group 2804"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2803",
    "data-name": "Group 2803"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1671",
    "data-name": "Path 1671",
    d: "M291.018,403.787a6.163,6.163,0,0,1-.507-1.223c-.3-.8-.686-1.965-1.147-3.415-.924-2.9-2.064-6.945-3.3-11.41s-2.434-8.487-3.4-11.363c-.479-1.439-.878-2.6-1.164-3.4a6.127,6.127,0,0,1-.386-1.266,5.915,5.915,0,0,1,.587,1.186c.349.776.806,1.921,1.333,3.348,1.065,2.853,2.324,6.871,3.564,11.343l3.146,11.448c.386,1.374.714,2.533.976,3.462A6.057,6.057,0,0,1,291.018,403.787Z",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2812",
    "data-name": "Group 2812"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2811",
    "data-name": "Group 2811"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2810",
    "data-name": "Group 2810"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2809",
    "data-name": "Group 2809"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2808",
    "data-name": "Group 2808"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1672",
    "data-name": "Path 1672",
    d: "M328.153,390.133a8.373,8.373,0,0,1-1.5.442c-.969.254-2.373.614-4.094,1.115-3.448.973-8.164,2.484-13.294,4.379s-9.7,3.826-12.959,5.311c-1.638.731-2.947,1.359-3.855,1.787a8.33,8.33,0,0,1-1.434.62,8.271,8.271,0,0,1,1.336-.816c.879-.488,2.165-1.172,3.786-1.952,3.23-1.582,7.79-3.568,12.933-5.479a137.106,137.106,0,0,1,13.384-4.235c1.74-.452,3.162-.755,4.15-.943A8.355,8.355,0,0,1,328.153,390.133Z",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2817",
    "data-name": "Group 2817"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2816",
    "data-name": "Group 2816"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2815",
    "data-name": "Group 2815"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2814",
    "data-name": "Group 2814"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2813",
    "data-name": "Group 2813"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1673",
    "data-name": "Path 1673",
    d: "M281.522,449.226a2,2,0,0,1-.342-.423l-.89-1.277c-.768-1.111-1.838-2.749-3.133-4.79-2.594-4.08-6-9.829-9.67-16.223s-7.02-12.169-9.524-16.3l-2.981-4.881-.8-1.333a1.993,1.993,0,0,1-.248-.487,2.089,2.089,0,0,1,.342.425c.241.345.535.765.89,1.275.769,1.112,1.839,2.75,3.134,4.79,2.593,4.08,6,9.829,9.671,16.226s7.018,12.166,9.523,16.3c1.225,2.005,2.232,3.655,2.98,4.881l.8,1.333A1.992,1.992,0,0,1,281.522,449.226Z",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2822",
    "data-name": "Group 2822"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2821",
    "data-name": "Group 2821"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2820",
    "data-name": "Group 2820"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2819",
    "data-name": "Group 2819"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2818",
    "data-name": "Group 2818"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1674",
    "data-name": "Path 1674",
    d: "M329.7,424.182a2.063,2.063,0,0,1-.471.294l-1.4.746-5.157,2.692c-4.355,2.274-10.333,5.483-16.934,9.038s-12.617,6.714-17.02,8.9c-2.2,1.093-3.991,1.959-5.24,2.532-.578.261-1.055.476-1.442.652a2.027,2.027,0,0,1-.52.192,2.127,2.127,0,0,1,.471-.3l1.4-.745,5.157-2.692c4.354-2.273,10.333-5.483,16.936-9.039s12.614-6.713,17.017-8.9c2.2-1.093,3.991-1.959,5.241-2.532l1.442-.652A2.061,2.061,0,0,1,329.7,424.182Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2847",
    "data-name": "Group 2847"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2825",
    "data-name": "Group 2825"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2824",
    "data-name": "Group 2824"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1675",
    "data-name": "Path 1675",
    d: "M153.4,247.411s-11.882,1.651-5.211,27.674,12.328,39.435,12.328,39.435.9,5.894-3.855,5.712-14.439-4.04-17.725,1.087c-3.409,5.318-.429,11.725,7.024,18.431s23.241,22,24.663,23.388c1.4,1.362,2.456,4.25-.8,4.644s-26.385-2.32-27.016,8.732,23.2,26.324,25.773,28.043,2.979,3.065,2.4,4.56-8.264-.15-14.874-.653-14.362.073-14.191,6.48,12.682,22.6,49.189,34.634l17.281,4.47,12.775-12.58c25.7-28.588,28.511-48.854,25.475-54.5s-10.049-2.291-15.535,1.43-11.34,8.968-12.583,7.958-1.561-2.38-.182-5.151,14.47-27.866,8.43-37.143-24.761,4.572-27.783,5.848-3.538-1.756-3-3.632c.544-1.912,6.646-23.029,9.78-32.552s2.537-16.564-3.063-19.484c-5.4-2.817-11.89,5.345-15.922,7.864s-6.185-3.041-6.185-3.041-1.755-14.45-8.9-40.347-18.532-21.258-18.532-21.258",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2828",
    "data-name": "Group 2828"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2827",
    "data-name": "Group 2827"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2826",
    "data-name": "Group 2826"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1676",
    "data-name": "Path 1676",
    d: "M208.367,458.346c-5.171-19.04-13.792-53.035-21.346-82.183s-14.413-55.512-19.487-74.577c-2.542-9.513-4.6-17.219-6.032-22.571l-1.636-6.138c-.176-.687-.313-1.219-.412-1.6-.09-.361-.122-.55-.122-.55s.069.179.177.535c.111.379.265.906.465,1.586.4,1.42.987,3.475,1.736,6.111,1.5,5.309,3.621,13.006,6.2,22.527,5.171,19.04,12.093,45.4,19.644,74.539s16.115,63.156,21.189,82.22",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2831",
    "data-name": "Group 2831"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2830",
    "data-name": "Group 2830"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2829",
    "data-name": "Group 2829"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1677",
    "data-name": "Path 1677",
    d: "M152.269,327.262a5.8,5.8,0,0,1,1.138.61c.716.421,1.732,1.06,2.98,1.861,2.494,1.607,5.881,3.914,9.572,6.527l9.426,6.724L178.252,345a5.823,5.823,0,0,1,1.026.784,5.721,5.721,0,0,1-1.143-.6c-.714-.423-1.731-1.062-2.972-1.876-2.477-1.632-5.833-3.983-9.524-6.6l-9.47-6.653-2.879-2.005A5.817,5.817,0,0,1,152.269,327.262Z",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2834",
    "data-name": "Group 2834"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2833",
    "data-name": "Group 2833"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2832",
    "data-name": "Group 2832"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1678",
    "data-name": "Path 1678",
    d: "M180.718,344.941c-.129-.083,4.319-7.275,9.934-16.063s10.274-15.848,10.4-15.765-4.318,7.273-9.936,16.064S180.847,345.023,180.718,344.941Z",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2837",
    "data-name": "Group 2837"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2836",
    "data-name": "Group 2836"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2835",
    "data-name": "Group 2835"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1679",
    "data-name": "Path 1679",
    d: "M190.3,390.217a6,6,0,0,1,.948-.916l2.7-2.359c2.272-1.994,5.4-4.762,8.738-7.942s6.275-6.151,8.378-8.323c.991-1.022,1.826-1.882,2.494-2.572a6.087,6.087,0,0,1,.962-.9,5.94,5.94,0,0,1-.8,1.047c-.545.649-1.349,1.574-2.368,2.694-2.033,2.245-4.926,5.275-8.282,8.457s-6.526,5.918-8.867,7.839c-1.175.956-2.134,1.719-2.812,2.227A5.982,5.982,0,0,1,190.3,390.217Z",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2840",
    "data-name": "Group 2840"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2839",
    "data-name": "Group 2839"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2838",
    "data-name": "Group 2838"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1680",
    "data-name": "Path 1680",
    d: "M161.047,379.89a5.191,5.191,0,0,1,1.184.287l3.164.98c2.665.849,6.332,2.058,10.373,3.427s7.69,2.637,10.322,3.582l3.107,1.145a5.234,5.234,0,0,1,1.116.492,5.182,5.182,0,0,1-1.185-.287l-3.164-.979c-2.664-.849-6.332-2.059-10.374-3.428s-7.688-2.637-10.321-3.581l-3.107-1.146A5.115,5.115,0,0,1,161.047,379.89Z",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2843",
    "data-name": "Group 2843"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2842",
    "data-name": "Group 2842"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2841",
    "data-name": "Group 2841"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1681",
    "data-name": "Path 1681",
    d: "M164.426,420.936a8.266,8.266,0,0,1,1.512.382l4.06,1.24c3.42,1.069,8.133,2.583,13.328,4.287s9.891,3.278,13.28,4.443l4,1.406a8.418,8.418,0,0,1,1.445.588,8.493,8.493,0,0,1-1.512-.382l-4.06-1.24c-3.42-1.069-8.134-2.583-13.331-4.288s-9.888-3.277-13.278-4.442l-4-1.406A8.423,8.423,0,0,1,164.426,420.936Z",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2846",
    "data-name": "Group 2846"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2845",
    "data-name": "Group 2845"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2844",
    "data-name": "Group 2844"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1682",
    "data-name": "Path 1682",
    d: "M201.239,432.734a9.56,9.56,0,0,1,1.172-1.191l3.31-3.114c2.792-2.632,6.633-6.282,10.761-10.431s7.777-7.993,10.4-10.8l3.1-3.32a9.753,9.753,0,0,1,1.185-1.176,9.551,9.551,0,0,1-1.024,1.319c-.687.826-1.7,2.005-2.975,3.441-2.546,2.875-6.151,6.774-10.293,10.925s-8.026,7.768-10.888,10.329c-1.435,1.276-2.606,2.3-3.432,2.985A9.685,9.685,0,0,1,201.239,432.734Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2848",
    "data-name": "Group 2848"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1683",
    "data-name": "Path 1683",
    d: "M101.8,92.239,92.04,89.194s-2.556,8.194-11.117,5.684a8.27,8.27,0,0,1-6.075-7.426,9.161,9.161,0,0,1,3.161-7.687c2.507-2.213,6.908-3.562,13.123-.351L98,57.41l-9.65-3.01L84.326,67.289S69.7,66.565,65.047,81.48c-4.452,14.271,7.312,21.577,12.79,23.286C82.026,106.073,96.612,109.513,101.8,92.239Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_211",
    "data-name": "Rectangle 211",
    width: 10.259,
    height: 9.581,
    transform: "matrix(-0.955, -0.298, 0.298, -0.955, 99.438, 52.885)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2849",
    "data-name": "Group 2849"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1684",
    "data-name": "Path 1684",
    d: "M128.734,67.395l3.908-1.03a3.435,3.435,0,0,1,2.529-4.24,3.27,3.27,0,0,1,3.6,1.211,3.621,3.621,0,0,1,.556,3.238c-.374,1.268-1.565,2.644-4.321,2.875l2.324,8.812,3.864-1.02-1.361-5.161a7.806,7.806,0,0,0,3.475-8.8c-1.508-5.714-6.983-5.69-9.176-5.111C132.449,58.608,126.842,60.521,128.734,67.395Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_212",
    "data-name": "Rectangle 212",
    width: 4.056,
    height: 3.788,
    transform: "matrix(0.967, -0.255, 0.255, 0.967, 137.793, 80.079)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2850",
    "data-name": "Group 2850"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1685",
    "data-name": "Path 1685",
    d: "M451.543,168.606l3.8,1.376a3.435,3.435,0,0,1,4.493-2.046,3.267,3.267,0,0,1,2.266,3.041,3.622,3.622,0,0,1-1.385,2.98c-1.03.829-2.792,1.283-5.189-.1l-3.1,8.568,3.757,1.361L458,178.772a7.806,7.806,0,0,0,7.868-5.261c2.013-5.557-2.5-8.653-4.636-9.426C459.6,163.495,453.9,161.876,451.543,168.606Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_213",
    "data-name": "Rectangle 213",
    width: 4.056,
    height: 3.788,
    transform: "translate(451.774 184.19) rotate(19.914)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2851",
    "data-name": "Group 2851"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1686",
    "data-name": "Path 1686",
    d: "M48.255,212.129l8.043-3.1s-2.6-6.752,4.369-9.577a6.973,6.973,0,0,1,7.9,1.726,7.724,7.724,0,0,1,1.937,6.734c-.5,2.775-2.7,5.97-8.487,7.1L69,233.151l7.953-3.064-4.093-10.622s10.043-7.18,5.308-19.471c-4.531-11.76-16.129-10.428-20.644-8.689C54.076,192.635,42.638,198,48.255,212.129Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_214",
    "data-name": "Rectangle 214",
    width: 8.649,
    height: 8.078,
    transform: "matrix(0.933, -0.359, 0.359, 0.933, 70.421, 236.895)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2852",
    "data-name": "Group 2852"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1687",
    "data-name": "Path 1687",
    d: "M454.67,242.639l-5.7,2.195s1.843,4.785-3.1,6.787a4.942,4.942,0,0,1-5.6-1.223,5.474,5.474,0,0,1-1.373-4.772c.353-1.966,1.913-4.231,6.015-5.034l-4.951-12.85-5.635,2.171,2.9,7.527a11.792,11.792,0,0,0-3.761,13.8c3.21,8.334,11.43,7.39,14.629,6.158C450.545,256.453,458.651,252.651,454.67,242.639Z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_215",
    "data-name": "Rectangle 215",
    width: 6.129,
    height: 5.724,
    transform: "translate(438.962 225.089) rotate(158.931)",
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2853",
    "data-name": "Group 2853"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1688",
    "data-name": "Path 1688",
    d: "M470.771,463.772c0,.143-98.85.26-220.76.26-121.953,0-220.782-.117-220.782-.26s98.829-.261,220.782-.261C371.921,463.511,470.771,463.628,470.771,463.772Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2879",
    "data-name": "Group 2879"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2856",
    "data-name": "Group 2856"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2855",
    "data-name": "Group 2855"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2854",
    "data-name": "Group 2854"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1689",
    "data-name": "Path 1689",
    d: "M92.637,437.8c.949-3.677-1.463-7.369-4.166-10.037s-5.934-5.059-7.341-8.587c-2.278-5.715.785-13.116-3.1-17.885-2.287-2.8-6.388-3.744-8.418-6.741a15.321,15.321,0,0,1-1.827-5.356,54.4,54.4,0,0,0-13.53-25.316,47.215,47.215,0,0,0,5.308,24.4c1.575,3,3.508,5.921,4.03,9.267.847,5.434-2.185,11.032-.851,16.367,1.527,6.1,8.381,10.185,8.706,16.466.274,5.31-4.354,9.971-4.009,15.277a14.331,14.331,0,0,0,2.363,6.3c4.106,6.825,10.137,11.527,19.279,11.374l11.2.392Z",
    fill: "#ff725e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2860",
    "data-name": "Group 2860",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2859",
    "data-name": "Group 2859"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2858",
    "data-name": "Group 2858"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2857",
    "data-name": "Group 2857"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1690",
    "data-name": "Path 1690",
    d: "M92.637,437.8c.949-3.677-1.463-7.369-4.166-10.037s-5.934-5.059-7.341-8.587c-2.278-5.715.785-13.116-3.1-17.885-2.287-2.8-6.388-3.744-8.418-6.741a15.321,15.321,0,0,1-1.827-5.356,54.4,54.4,0,0,0-13.53-25.316,47.215,47.215,0,0,0,5.308,24.4c1.575,3,3.508,5.921,4.03,9.267.847,5.434-2.185,11.032-.851,16.367,1.527,6.1,8.381,10.185,8.706,16.466.274,5.31-4.354,9.971-4.009,15.277a14.331,14.331,0,0,0,2.363,6.3c4.106,6.825,10.137,11.527,19.279,11.374l11.2.392Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2878",
    "data-name": "Group 2878"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2869",
    "data-name": "Group 2869"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2864",
    "data-name": "Group 2864"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2863",
    "data-name": "Group 2863"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2862",
    "data-name": "Group 2862"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2861",
    "data-name": "Group 2861"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1691",
    "data-name": "Path 1691",
    d: "M102.543,464.012a8.945,8.945,0,0,0,3.083-.067,18.689,18.689,0,0,0,3.639-.916,15.425,15.425,0,0,0,4.494-2.461,6.273,6.273,0,0,0,1.848-2.463,11.589,11.589,0,0,0,.527-3.346,32.318,32.318,0,0,1,.262-3.622,9.981,9.981,0,0,1,1.368-3.6c1.32-2.319,3.512-4.515,4.22-7.664.767-3.1.217-6.449-.3-9.815s-1.023-7.02.261-10.519c1.2-3.5,3.657-6.664,4.885-10.612,1.222-3.987.652-8.276.911-12.505A16.589,16.589,0,0,1,129.2,390.2c.906-1.982,2.163-3.851,3.144-5.938,1.987-4.218,2.338-9,2.882-13.684q.4-3.541.8-7.155a35,35,0,0,1,1.244-7.161,63.05,63.05,0,0,1,2.679-6.93,22.981,22.981,0,0,0,1.3-3.62,36.356,36.356,0,0,0,.361-3.851,45.345,45.345,0,0,0-.3-7.751c-.3-2.584-.77-5.146-1.048-7.735-.017-.153-.034-.306-.05-.447l-.058-.516-.459.23a17.291,17.291,0,0,0-6.027,5.087,27.425,27.425,0,0,0-3.7,6.825c-1.87,4.811-2.544,9.853-3.487,14.663-.92,4.812-2.134,9.544-4.6,13.543-1.227,1.994-2.711,3.815-4.01,5.76a15.826,15.826,0,0,0-2.779,6.382c-.662,4.737,1.947,8.9,1.4,13.091a14.529,14.529,0,0,1-2.043,5.812c-1.017,1.789-2.212,3.448-3.346,5.115a32.915,32.915,0,0,0-3,5.167,16.349,16.349,0,0,0-1.376,5.613c-.273,3.776.263,7.358-.014,10.74a24.7,24.7,0,0,1-2.763,9.2c-1.354,2.755-2.861,5.246-4.123,7.662a39.474,39.474,0,0,0-1.7,3.568,17.569,17.569,0,0,0-.983,3.54,22.361,22.361,0,0,0-.082,6.391,16.107,16.107,0,0,0,3.2,8.151,7.81,7.81,0,0,0,.906.981,4.5,4.5,0,0,0,.735.624c.418.308.641.449.641.449a14.148,14.148,0,0,1-2.168-2.144,16.214,16.214,0,0,1-3.04-8.1,22.229,22.229,0,0,1,.143-6.3,17.287,17.287,0,0,1,.99-3.456,38.855,38.855,0,0,1,1.708-3.521c1.272-2.395,2.794-4.876,4.178-7.648a25.143,25.143,0,0,0,2.86-9.365c.294-3.454-.226-7.049.059-10.736a15.816,15.816,0,0,1,1.35-5.425,32.383,32.383,0,0,1,2.972-5.063c1.133-1.656,2.342-3.321,3.387-5.148a15.117,15.117,0,0,0,2.137-6.049c.54-4.468-2.05-8.656-1.377-13.059a15.194,15.194,0,0,1,2.684-6.1c1.279-1.909,2.771-3.732,4.035-5.776,2.545-4.114,3.778-8.937,4.708-13.768.951-4.841,1.626-9.829,3.463-14.541a26.751,26.751,0,0,1,3.606-6.646,16.583,16.583,0,0,1,5.774-4.877l-.516-.286c.016.142.034.3.051.451.281,2.621.749,5.188,1.05,7.742a44.706,44.706,0,0,1,.3,7.632,36.391,36.391,0,0,1-.345,3.736,22.471,22.471,0,0,1-1.256,3.491,63.733,63.733,0,0,0-2.7,7.006,35.686,35.686,0,0,0-1.261,7.28q-.4,3.615-.794,7.16c-.535,4.706-.886,9.41-2.8,13.482-.946,2.027-2.2,3.9-3.133,5.949a17.249,17.249,0,0,0-1.5,6.447c-.244,4.321.319,8.545-.85,12.373-1.161,3.81-3.6,6.988-4.838,10.6-1.321,3.651-.774,7.432-.24,10.78.541,3.371,1.084,6.653.363,9.63-.648,3.008-2.776,5.183-4.124,7.569a10.372,10.372,0,0,0-1.389,3.744,32.274,32.274,0,0,0-.235,3.666,11.37,11.37,0,0,1-.478,3.254,6,6,0,0,1-1.737,2.357,15.4,15.4,0,0,1-4.386,2.474,19.333,19.333,0,0,1-3.588.973,14.372,14.372,0,0,1-2.277.22C102.81,464,102.543,464.012,102.543,464.012Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2868",
    "data-name": "Group 2868"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2867",
    "data-name": "Group 2867"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2866",
    "data-name": "Group 2866"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2865",
    "data-name": "Group 2865"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1692",
    "data-name": "Path 1692",
    d: "M137.923,332.1a1.334,1.334,0,0,0-.108.338c-.066.268-.147.6-.247,1.008-.22.882-.483,2.214-.906,3.877-.439,1.659-1.455,3.535-2.324,5.849-.9,2.294-1.819,4.954-2.661,7.942s-1.612,6.3-2.4,9.855c-.816,3.546-1.63,7.349-3.584,10.935-.918,1.819-1.952,3.66-2.772,5.674A26.42,26.42,0,0,0,121.306,384a130,130,0,0,1-2.414,13.546c-2.246,9.177-4.384,17.916-6.331,25.875-1.995,7.93-3.792,15.077-5.307,21.1-1.474,5.97-2.672,10.82-3.517,14.241q-.583,2.463-.921,3.882c-.089.411-.163.744-.221,1.013a1.278,1.278,0,0,0-.052.352,1.341,1.341,0,0,0,.123-.333c.077-.265.173-.593.291-1,.255-.934.607-2.22,1.052-3.847l3.738-14.186c1.558-6.013,3.4-13.147,5.456-21.063,1.965-7.961,4.124-16.7,6.391-25.881A128.323,128.323,0,0,0,122,384.1a25.835,25.835,0,0,1,1.552-6.27c.791-1.962,1.809-3.794,2.727-5.632,1.97-3.655,2.79-7.573,3.575-11.105.766-3.562,1.491-6.868,2.31-9.848s1.684-5.637,2.547-7.934c.823-2.306,1.806-4.2,2.219-5.919.388-1.705.6-3.023.777-3.921.071-.414.13-.751.177-1.023A1.305,1.305,0,0,0,137.923,332.1Z",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2877",
    "data-name": "Group 2877"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2872",
    "data-name": "Group 2872"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2871",
    "data-name": "Group 2871"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2870",
    "data-name": "Group 2870"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1693",
    "data-name": "Path 1693",
    d: "M104.519,464.046c7.314-4.347,9.413-17.543,6.362-25.486s-8.391-15.2-9.214-23.668c-.633-6.51,1.5-13.191-.018-19.553C99.6,386.752,91.22,380.1,91.317,371.275c.054-4.953,2.872-9.613,2.647-14.56-.275-6.069-4.933-10.884-7.818-16.23-4.416-8.183-4.706-17.857-6.216-27.032s-5.007-19-13.139-23.511c-1.2,7.79-3.25,13.125-2.607,23.677.232,3.79,4.634,11.045,5.233,19.351.358,4.964.606,9.936.91,14.9.295,4.834.608,9.757,2.341,14.28,1.328,3.466,3.461,6.614,4.447,10.193,1.855,6.732-.582,14.023.916,20.844,1.269,5.778,5.268,10.751,6.085,16.611,1.148,8.232-4.18,16.786-1.453,24.639,1.354,3.9,4.559,7.026,5.469,11.049.706,3.122-.064,6.427.575,9.563,1.03,5.053,10.667,8.977,15.814,8.665",
    fill: "#ff725e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2876",
    "data-name": "Group 2876"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2875",
    "data-name": "Group 2875"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2874",
    "data-name": "Group 2874"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2873",
    "data-name": "Group 2873"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1694",
    "data-name": "Path 1694",
    d: "M68.807,297.675a2.041,2.041,0,0,0,.032.439c.042.328.1.75.165,1.281.168,1.125.356,2.777.737,4.913.408,2.148,1.515,4.566,2.4,7.482.934,2.906,1.862,6.26,2.683,10.015s1.533,7.906,2.266,12.376c.757,4.437,1.532,9.341,3.749,13.994,1.026,2.338,2.177,4.678,3.041,7.171a32.2,32.2,0,0,1,1.542,7.9,159.43,159.43,0,0,0,2.146,17.038c2.24,11.542,4.373,22.535,6.315,32.541,2.047,9.967,3.891,18.946,5.444,26.505l3.731,17.857c.448,2.068.8,3.692,1.05,4.848.121.521.217.935.291,1.257a2,2,0,0,0,.123.423,1.994,1.994,0,0,0-.051-.438c-.056-.325-.129-.744-.221-1.271-.218-1.162-.526-2.8-.918-4.875-.837-4.275-2.033-10.378-3.507-17.9-1.509-7.568-3.3-16.557-5.292-26.535-1.924-10-4.037-20.994-6.257-32.532a161.6,161.6,0,0,1-2.152-16.982,32.777,32.777,0,0,0-1.6-8.061c-.89-2.547-2.057-4.9-3.084-7.215-2.2-4.585-2.978-9.373-3.767-13.826-.758-4.462-1.488-8.627-2.358-12.387s-1.823-7.123-2.8-10.029c-.929-2.926-2.07-5.323-2.509-7.417-.416-2.1-.654-3.765-.867-4.876-.1-.526-.175-.944-.235-1.269A1.921,1.921,0,0,0,68.807,297.675Z",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble",
    "data-name": "Speech Bubble"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2887",
    "data-name": "Group 2887"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2880",
    "data-name": "Group 2880"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1695",
    "data-name": "Path 1695",
    d: "M421.474,88.773h-3.981a3.383,3.383,0,0,1-3.473,3.4,3.222,3.222,0,0,1-3.12-2.056,3.568,3.568,0,0,1,.284-3.224c.675-1.114,2.155-2.125,4.837-1.653V76.267h-3.936v5.258a7.686,7.686,0,0,0-5.52,7.511c0,5.821,5.22,7.173,7.454,7.173C415.728,96.209,421.549,95.8,421.474,88.773Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_216",
    "data-name": "Rectangle 216",
    width: 3.995,
    height: 3.731,
    transform: "translate(416.033 74.418) rotate(180)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2886",
    "data-name": "Group 2886"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2885",
    "data-name": "Group 2885"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2884",
    "data-name": "Group 2884"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2883",
    "data-name": "Group 2883"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2882",
    "data-name": "Group 2882"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2881",
    "data-name": "Group 2881"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1696",
    "data-name": "Path 1696",
    d: "M443.276,83.446a2.861,2.861,0,0,0,.008-.5c-.01-.366-.024-.856-.042-1.481-.015-.325-.015-.691-.048-1.091q-.086-.6-.184-1.306l-.219-1.524q-.2-.8-.422-1.7a27.572,27.572,0,0,0-3.6-8.253A29.119,29.119,0,0,0,416.882,54.21a30.06,30.06,0,0,0-3.991-.081c-.674.047-1.361.034-2.041.132l-2.055.31a29.274,29.274,0,0,0-8.121,2.773,31.256,31.256,0,0,0-7.3,5.3,30.644,30.644,0,0,0-5.49,7.642,27.761,27.761,0,0,0-2.859,9.315,18.493,18.493,0,0,0-.211,2.484,22.356,22.356,0,0,0-.046,2.511,29.758,29.758,0,0,0,.636,5.031,29.4,29.4,0,0,0,4.214,10.014l-.031-.3q-2.089,5.208-4.094,10.2l-.243.6.628-.172,10.9-3-.269-.051a29.275,29.275,0,0,0,12.461,5.443,26.516,26.516,0,0,0,6.385.4,20.507,20.507,0,0,0,3.066-.29l1.492-.231c.491-.092.966-.241,1.445-.357A29.176,29.176,0,0,0,437.956,100.5a27.887,27.887,0,0,0,3.573-6.773l.546-1.526q.192-.753.368-1.448t.328-1.325c.082-.425.126-.835.185-1.22.1-.771.231-1.448.26-2.042s.036-1.084.05-1.5c.009-.38.015-.682.021-.916a1.409,1.409,0,0,0-.011-.31,1.44,1.44,0,0,0-.043.31c-.018.233-.042.533-.072.911q-.041.62-.1,1.49c-.046.589-.2,1.26-.308,2.023a29.009,29.009,0,0,1-21.517,23.195c-.47.112-.937.257-1.42.344l-1.466.22a20.169,20.169,0,0,1-3.011.27,25.992,25.992,0,0,1-6.258-.414,28.738,28.738,0,0,1-12.191-5.368l-.122-.092-.147.04-10.912,2.976.385.432q2.007-4.984,4.106-10.2l.064-.16-.1-.144a28.8,28.8,0,0,1-4.116-9.791,29.235,29.235,0,0,1-.622-4.917,21.85,21.85,0,0,1,.044-2.456,17.842,17.842,0,0,1,.2-2.429,27.171,27.171,0,0,1,2.786-9.11,30.087,30.087,0,0,1,5.357-7.485,30.714,30.714,0,0,1,7.132-5.209,28.763,28.763,0,0,1,7.946-2.743l2.014-.311c.666-.1,1.339-.088,2-.137A28.752,28.752,0,0,1,438.46,67.787a27.748,27.748,0,0,1,3.661,8.119q.236.888.447,1.681l.248,1.508q.115.7.213,1.293c.044.4.054.76.08,1.083.045.622.081,1.109.107,1.473A2.753,2.753,0,0,0,443.276,83.446Z",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Question_Mark",
    "data-name": "Question Mark"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2896",
    "data-name": "Group 2896"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2890",
    "data-name": "Group 2890"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2888",
    "data-name": "Group 2888"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1697",
    "data-name": "Path 1697",
    d: "M145.067,201.384h57.754s0-48.491,50.392-49.359c26.172-.45,39.741,16.693,45.254,29.826,6.4,15.251,4.465,32.633-4.113,46.776-9.8,16.15-30.892,32.379-69.813,25.521l-.369,128.669h57.106V306.539s80.092-20.7,80.092-108.968c0-84.451-68.293-102.695-104.995-103.867-20.425-.652-27.828-1.53-53.087,2.056C171.1,100.33,144.386,137.706,145.067,201.384Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_217",
    "data-name": "Rectangle 217",
    width: 57.956,
    height: 54.129,
    transform: "translate(224.012 409.643)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_218",
    "data-name": "Rectangle 218",
    width: 57.956,
    height: 54.129,
    transform: "translate(224.012 409.643)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1698",
    "data-name": "Path 1698",
    d: "M145.067,201.384h57.754s0-48.491,50.392-49.359c26.172-.45,39.741,16.693,45.254,29.826,6.4,15.251,4.465,32.633-4.113,46.776-9.8,16.15-30.892,32.379-69.813,25.521l-.369,128.669h57.106V306.539s80.092-20.7,80.092-108.968c0-84.451-68.293-102.695-104.995-103.867-20.425-.652-27.828-1.53-53.087,2.056C171.1,100.33,144.386,137.706,145.067,201.384Z",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2889",
    "data-name": "Group 2889"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1699",
    "data-name": "Path 1699",
    d: "M121.144,201.384H178.9s0-48.491,50.393-49.359c26.171-.45,39.74,16.693,45.254,29.826,6.4,15.251,4.464,32.633-4.114,46.776-9.8,16.15-31.261,30.83-70.182,23.973V382.817h57.106V306.539s80.092-20.7,80.092-108.968c0-84.451-75.733-104.066-108.151-104.065C204.505,93.506,120.055,99.5,121.144,201.384Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1700",
    "data-name": "Path 1700",
    d: "M121.144,201.384H178.9s0-48.491,50.393-49.359c26.171-.45,39.74,16.693,45.254,29.826,6.4,15.251,4.464,32.633-4.114,46.776-9.8,16.15-31.261,30.83-70.182,23.973V382.817h57.106V306.539s80.092-20.7,80.092-108.968c0-84.451-75.733-104.066-108.151-104.065C204.505,93.506,120.055,99.5,121.144,201.384Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_219",
    "data-name": "Rectangle 219",
    width: 57.956,
    height: 54.129,
    transform: "translate(200.089 409.643)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_220",
    "data-name": "Rectangle 220",
    width: 57.956,
    height: 54.129,
    transform: "translate(200.089 409.643)",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2891",
    "data-name": "Group 2891"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1701",
    "data-name": "Path 1701",
    d: "M235.813,152.294a5.361,5.361,0,0,1-.864-.053c-.565-.028-1.387-.187-2.461-.2a50.321,50.321,0,0,0-9.056.375,64.889,64.889,0,0,0-13.073,3.075,55.8,55.8,0,0,0-7.284,3.133,38.728,38.728,0,0,0-7.123,4.614,35.33,35.33,0,0,0-5.83,6.159A56.985,56.985,0,0,0,180.58,188.4a50.01,50.01,0,0,0-1.737,8.9c-.123,1.066-.155,1.9-.184,2.462a5.441,5.441,0,0,1-.078.862,5.306,5.306,0,0,1-.027-.864c-.005-.567-.005-1.4.088-2.478a46.288,46.288,0,0,1,1.584-8.976,57.346,57.346,0,0,1,5.108-12.52,58.405,58.405,0,0,1,4.383-6.7,35.486,35.486,0,0,1,5.9-6.252,38.812,38.812,0,0,1,7.22-4.664,55.21,55.21,0,0,1,7.361-3.133,63.2,63.2,0,0,1,13.186-2.988,46.723,46.723,0,0,1,9.113-.212c1.077.044,1.9.236,2.462.3A5.351,5.351,0,0,1,235.813,152.294Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2892",
    "data-name": "Group 2892"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1702",
    "data-name": "Path 1702",
    d: "M322.829,141.983a1.22,1.22,0,0,1-.188-.227c-.131-.181-.3-.409-.506-.695l-1.9-2.7c-.417-.582-.851-1.25-1.376-1.944l-1.8-2.188-2.068-2.515c-.752-.873-1.629-1.723-2.5-2.655-.9-.913-1.787-1.918-2.8-2.876l-3.229-2.919c-.563-.5-1.113-1.032-1.712-1.526l-1.861-1.465c-1.269-.978-2.53-2.044-3.9-3.028a125.017,125.017,0,0,0-18.923-11.176l-5.269-2.383-5.236-2.032c-1.7-.706-3.443-1.208-5.124-1.764-1.692-.524-3.32-1.132-4.969-1.518l-4.783-1.256c-1.55-.411-3.091-.654-4.561-.975-1.479-.276-2.89-.644-4.277-.816l-3.977-.575c-2.526-.433-4.846-.52-6.87-.724-1.014-.079-1.956-.188-2.826-.228l-2.382-.064-3.3-.106-.858-.041a1.22,1.22,0,0,1-.293-.032,1.243,1.243,0,0,1,.292-.022l.859-.01,3.3.008,2.389.019c.872.026,1.817.12,2.835.186,2.03.177,4.359.238,6.9.648l3.994.544c1.394.163,2.811.522,4.3.79,1.477.312,3.025.548,4.582.952l4.806,1.24c1.657.381,3.294.985,4.993,1.507,1.69.553,3.438,1.053,5.149,1.758l5.259,2.033,5.293,2.391a122.8,122.8,0,0,1,18.982,11.258c1.377.994,2.64,2.071,3.909,3.059l1.861,1.482c.6.5,1.149,1.038,1.711,1.542l3.223,2.954c1.012.97,1.9,1.987,2.79,2.911.87.945,1.74,1.807,2.486,2.691l2.044,2.551,1.775,2.221c.515.705.939,1.384,1.343,1.977L322.224,141l.462.723A1.306,1.306,0,0,1,322.829,141.983Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2893",
    "data-name": "Group 2893"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1703",
    "data-name": "Path 1703",
    d: "M316.812,265.978a3.989,3.989,0,0,1-.437.6q-.5.629-1.332,1.657c-.577.721-1.3,1.591-2.18,2.562s-1.844,2.115-3.006,3.289c-1.139,1.2-2.394,2.5-3.809,3.831-1.378,1.372-2.94,2.739-4.566,4.2a125.082,125.082,0,0,1-23.359,16.1c-1.942,1-3.776,1.976-5.547,2.776-1.747.85-3.412,1.559-4.935,2.2-1.511.668-2.92,1.167-4.144,1.64s-2.29.844-3.169,1.126l-2.022.656a4.032,4.032,0,0,1-.715.195,3.93,3.93,0,0,1,.682-.294l1.987-.748c.867-.311,1.924-.7,3.133-1.207s2.606-1.019,4.1-1.707c1.51-.658,3.161-1.385,4.894-2.249,1.757-.813,3.577-1.8,5.5-2.808,3.816-2.094,7.925-4.557,12.071-7.4,4.126-2.865,7.888-5.828,11.2-8.65,1.628-1.443,3.2-2.793,4.582-4.146,1.424-1.313,2.689-2.6,3.841-3.774,1.176-1.154,2.16-2.274,3.055-3.229s1.643-1.8,2.243-2.5l1.4-1.592A3.957,3.957,0,0,1,316.812,265.978Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2894",
    "data-name": "Group 2894"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1704",
    "data-name": "Path 1704",
    d: "M256.345,378.283c-.144,0-.261-16.063-.261-35.873s.117-35.876.261-35.876.26,16.06.26,35.876S256.489,378.283,256.345,378.283Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2895",
    "data-name": "Group 2895"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1705",
    "data-name": "Path 1705",
    d: "M258.548,460.1c-.144,0-.261-11.272-.261-25.173s.117-25.176.261-25.176.26,11.269.26,25.176S258.691,460.1,258.548,460.1Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3111",
    "data-name": "Group 3111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2913",
    "data-name": "Group 2913"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1706",
    "data-name": "Path 1706",
    d: "M315.4,193.709c-1.009,2.013,2.728,3.637,4.884,4.289a19.535,19.535,0,0,0,6.705.462c2.98-.161,6.068-.439,8.66-1.92a13.762,13.762,0,0,0,5.219-5.854,41.019,41.019,0,0,0,2.65-7.488S319.891,184.745,315.4,193.709Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2897",
    "data-name": "Group 2897",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1707",
    "data-name": "Path 1707",
    d: "M315.4,193.709c-1.009,2.013,2.728,3.637,4.884,4.289a19.535,19.535,0,0,0,6.705.462c2.98-.161,6.068-.439,8.66-1.92a13.762,13.762,0,0,0,5.219-5.854,41.019,41.019,0,0,0,2.65-7.488S319.891,184.745,315.4,193.709Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2899",
    "data-name": "Group 2899"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1708",
    "data-name": "Path 1708",
    d: "M382.144,187.306a22.656,22.656,0,0,0,13.336,4.187c2.27-.027,4.675-.466,6.35-2,.771-.705,1.346-1.606,2.14-2.284.539-.46,1.17-.81,1.677-1.305a2.146,2.146,0,0,0,.736-1.9A3.958,3.958,0,0,0,405,181.8c-2.714-1.54-5.951-1.484-9.07-1.413a31.1,31.1,0,0,0-9.15,1.794c-2.419.814-4.954,1.963-6.18,4.2",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2898",
    "data-name": "Group 2898",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1709",
    "data-name": "Path 1709",
    d: "M406.383,184.009A4.188,4.188,0,0,0,404.609,182c-2.713-1.54-5.558-1.683-8.678-1.612a31.1,31.1,0,0,0-9.149,1.794c-2.419.814-4.954,1.963-6.18,4.2l1.542.924a22.656,22.656,0,0,0,13.336,4.187c2.27-.027,4.675-.466,6.35-2,.771-.705,1.346-1.606,2.14-2.284.539-.46,1.17-.81,1.677-1.305A2.146,2.146,0,0,0,406.383,184.009Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1710",
    "data-name": "Path 1710",
    d: "M336.02,223.2l49.851.653a.641.641,0,0,0,.618-.836l-5.847-18.241s.861-9.114,2.052-20.083c1.808-16.644,4.212-37.573,4.243-37.516-3.4-9.555-23.524-11.184-23.524-11.184l-22.931,1.363-.807-1.345-6.6,3.068a30.5,30.5,0,0,0-4.14,2.334c-4.354,2.918-14.862,9.6-16.776,17.058-4.427,17.242,3.072,36.493,3.072,36.493l4.813-3.763a33.789,33.789,0,0,1,3.821-2.553l9.661,25.885a4.565,4.565,0,0,0-2.1,3.323c-.085,2.1,1.04,4.626,4.588,5.344",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2900",
    "data-name": "Group 2900",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1711",
    "data-name": "Path 1711",
    d: "M357.39,192.681c1.581-8.5.745-17.236-.1-25.839-2.768,7.038-2.667,14.97-5.6,21.942a9.379,9.379,0,0,0-.78,2.31,2.58,2.58,0,0,0,.666,2.255c.8.728,1.983.336,3.054.207a11.668,11.668,0,0,0,2.752-.875"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2901",
    "data-name": "Group 2901",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1712",
    "data-name": "Path 1712",
    d: "M339.028,212.355c4.025,1.4,8.257-1.193,12.492-1.653,2.8-.3,5.6.338,8.377.789a62.628,62.628,0,0,0,17,.417,6.505,6.505,0,0,0,2.5-.646,3.017,3.017,0,0,0,1.308-2.482c-9.414-.966-18.83-1.542-28.244-2.508a17.752,17.752,0,0,0-7.061.224c-2.846.882-5.039,3.117-7.045,5.32"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1713",
    "data-name": "Path 1713",
    d: "M404.944,180.715c-4.076-9.163-18.425-34.525-18.425-34.525L375.4,160.124,378,187.475s5.868-6.551,22.277-6.682a8.043,8.043,0,0,1,6.107,3.216Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2902",
    "data-name": "Group 2902"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1714",
    "data-name": "Path 1714",
    d: "M338.228,175.874a37.827,37.827,0,0,1-1.873-5.981,37.85,37.85,0,0,1-1.37-6.117,37.855,37.855,0,0,1,1.873,5.982A38.058,38.058,0,0,1,338.228,175.874Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2903",
    "data-name": "Group 2903"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1715",
    "data-name": "Path 1715",
    d: "M374.566,158.269a6.737,6.737,0,0,1,1.028.874,28.145,28.145,0,0,1,2.476,2.721,26.245,26.245,0,0,1,5.306,10.859,20.3,20.3,0,0,1,.319,6.7c-.258,2.046-.65,3.845-.9,5.368s-.42,2.758-.5,3.616a8.935,8.935,0,0,1-.139,1.337,5.348,5.348,0,0,1-.063-1.348,31.677,31.677,0,0,1,.339-3.662c.2-1.536.56-3.351.787-5.368a20.577,20.577,0,0,0-.351-6.534,27.49,27.49,0,0,0-5.088-10.741C375.93,159.626,374.489,158.345,374.566,158.269Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2904",
    "data-name": "Group 2904"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1716",
    "data-name": "Path 1716",
    d: "M364.388,221.023a4.654,4.654,0,0,1-1.085.316,10.417,10.417,0,0,1-1.3.252,17.52,17.52,0,0,1-1.745.213,25.84,25.84,0,0,1-4.578-.026,27.193,27.193,0,0,1-10.661-3.31,25.768,25.768,0,0,1-3.788-2.572,17.414,17.414,0,0,1-1.318-1.163,10.43,10.43,0,0,1-.929-.945,4.674,4.674,0,0,1-.716-.875c.075-.072,1.148,1.129,3.191,2.694a28.761,28.761,0,0,0,3.79,2.44,28.743,28.743,0,0,0,10.48,3.254,28.749,28.749,0,0,0,4.505.135C362.8,221.3,364.367,220.922,364.388,221.023Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2905",
    "data-name": "Group 2905"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1717",
    "data-name": "Path 1717",
    d: "M379.783,215.32a3.531,3.531,0,0,1,.385,1.46,9.01,9.01,0,0,1-.269,3.644,6.354,6.354,0,0,1-1.959,3.1,2.761,2.761,0,0,1-1.318.751c-.044-.075.442-.38,1.067-1.02a7.086,7.086,0,0,0,1.711-2.977C380.157,217.634,379.587,215.332,379.783,215.32Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2906",
    "data-name": "Group 2906"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1718",
    "data-name": "Path 1718",
    d: "M377.072,218.843a5.435,5.435,0,0,1-2.141,5.519c-.111-.109.823-1.1,1.4-2.631C376.935,220.213,376.917,218.849,377.072,218.843Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2907",
    "data-name": "Group 2907"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1719",
    "data-name": "Path 1719",
    d: "M368.146,185.938a20.223,20.223,0,0,1-1.779,2.56,20.343,20.343,0,0,1-1.748,2.58,9.28,9.28,0,0,1,3.527-5.14Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2908",
    "data-name": "Group 2908"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1720",
    "data-name": "Path 1720",
    d: "M333.933,161.721a25.2,25.2,0,0,1-2.211-1.465,28.471,28.471,0,0,0-11.81-4.409,25.271,25.271,0,0,1-2.63-.342,9.224,9.224,0,0,1,2.671-.024,23.917,23.917,0,0,1,11.978,4.472A9.263,9.263,0,0,1,333.933,161.721Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2909",
    "data-name": "Group 2909"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1721",
    "data-name": "Path 1721",
    d: "M386.525,145.858a43.41,43.41,0,0,0-5.053,4.728,43.394,43.394,0,0,0-3.8,5.785,6.168,6.168,0,0,1,.7-1.94,19.821,19.821,0,0,1,6.36-7.555A6.179,6.179,0,0,1,386.525,145.858Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2910",
    "data-name": "Group 2910"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1722",
    "data-name": "Path 1722",
    d: "M365.938,137.618a1.9,1.9,0,0,1,.225.462,8.6,8.6,0,0,1,.466,1.4,11.862,11.862,0,0,1-.019,5.415,13.31,13.31,0,0,1-4.079,6.892,13.83,13.83,0,0,1-9.2,3.277,15.569,15.569,0,0,1-9.289-3.1,17.766,17.766,0,0,1-5.112-6.2,18.9,18.9,0,0,1-1.7-5.146,13.715,13.715,0,0,1-.179-1.462,1.9,1.9,0,0,1-.01-.514c.053-.006.114.7.388,1.937a20.489,20.489,0,0,0,1.831,5.017,17.8,17.8,0,0,0,5.071,5.979,15.269,15.269,0,0,0,9.006,2.969,13.479,13.479,0,0,0,8.882-3.117,13.137,13.137,0,0,0,4.037-6.617,12.271,12.271,0,0,0,.179-5.286C366.184,138.285,365.877,137.641,365.938,137.618Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2911",
    "data-name": "Group 2911",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1723",
    "data-name": "Path 1723",
    d: "M369.436,187.711c-.015-.5-.08-1.088-.514-1.338a.984.984,0,0,0-.906.015,2.547,2.547,0,0,0-.724.6,12.233,12.233,0,0,0-2.672,4.27l4.9-.423C369.49,189.8,369.468,188.745,369.436,187.711Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2912",
    "data-name": "Group 2912",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1724",
    "data-name": "Path 1724",
    d: "M385.708,177.4a16.045,16.045,0,0,0-3.553-7.6c2.111,6.921,1.4,10.826.217,15.565l.256-.663C383.99,181.936,386.084,180.2,385.708,177.4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2933",
    "data-name": "Group 2933"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2914",
    "data-name": "Group 2914"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1725",
    "data-name": "Path 1725",
    d: "M375.917,409.859l-2.991,44.854-19.5-.229-3.071-46.631Z",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2932",
    "data-name": "Group 2932"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2931",
    "data-name": "Group 2931"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2916",
    "data-name": "Group 2916"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2915",
    "data-name": "Group 2915"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1726",
    "data-name": "Path 1726",
    d: "M373.483,448.809l0,1.3s21.981,8.847,22.212,13.019l-43.659-.256.679-14.525C359.192,451.389,365.984,451.767,373.483,448.809Z",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2919",
    "data-name": "Group 2919"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2918",
    "data-name": "Group 2918"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2917",
    "data-name": "Group 2917"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1727",
    "data-name": "Path 1727",
    d: "M357.112,453.015a1.783,1.783,0,0,0-1.244,2.028,1.713,1.713,0,0,0,2,1.251,1.88,1.88,0,0,0,1.307-2.154,1.778,1.778,0,0,0-2.223-1.071",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2921",
    "data-name": "Group 2921"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2920",
    "data-name": "Group 2920"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1728",
    "data-name": "Path 1728",
    d: "M352.04,462.869l.163-3.493,41.785,1.524s1.939.857,1.711,2.225Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2924",
    "data-name": "Group 2924"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2923",
    "data-name": "Group 2923"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2922",
    "data-name": "Group 2922"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1729",
    "data-name": "Path 1729",
    d: "M373.639,450.229c-.008.213-1.075.3-2.128.983-1.07.652-1.616,1.572-1.812,1.486-.2-.042.129-1.315,1.418-2.115S373.687,450.034,373.639,450.229Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2927",
    "data-name": "Group 2927"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2926",
    "data-name": "Group 2926"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2925",
    "data-name": "Group 2925"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1730",
    "data-name": "Path 1730",
    d: "M378.207,452.15c.048.207-.877.564-1.607,1.462-.756.875-.944,1.849-1.156,1.839-.2.032-.341-1.217.587-2.316S378.2,451.947,378.207,452.15Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2930",
    "data-name": "Group 2930"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2929",
    "data-name": "Group 2929"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2928",
    "data-name": "Group 2928"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1731",
    "data-name": "Path 1731",
    d: "M380.776,457.646c-.194.044-.484-1.023.07-2.187s1.554-1.623,1.643-1.445c.12.176-.531.8-.972,1.761C381.054,456.727,380.988,457.626,380.776,457.646Z",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3040",
    "data-name": "Group 3040"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1732",
    "data-name": "Path 1732",
    d: "M372.361,81.854c1.125-2.8-.238-6.2-2.673-7.986a11.607,11.607,0,0,0-8.663-1.7,34.477,34.477,0,0,0-8.542,2.951,9.643,9.643,0,0,0-16.368,5.345,6.128,6.128,0,0,0-7.261,8.049l13.517,4.748,14.762,25.967a11.81,11.81,0,0,0,17.379-15.7,10.133,10.133,0,0,0,2.074-2.565,10.347,10.347,0,0,0,4.777-6.4C382.648,88.851,378.173,82.535,372.361,81.854Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3034",
    "data-name": "Group 3034"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3011",
    "data-name": "Group 3011"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3010",
    "data-name": "Group 3010"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3008",
    "data-name": "Group 3008"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3007",
    "data-name": "Group 3007"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3006",
    "data-name": "Group 3006"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3005",
    "data-name": "Group 3005"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2990",
    "data-name": "Group 2990"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2989",
    "data-name": "Group 2989"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2988",
    "data-name": "Group 2988"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2940",
    "data-name": "Group 2940"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2939",
    "data-name": "Group 2939"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2938",
    "data-name": "Group 2938"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2937",
    "data-name": "Group 2937"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2936",
    "data-name": "Group 2936"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2935",
    "data-name": "Group 2935"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2934",
    "data-name": "Group 2934"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1733",
    "data-name": "Path 1733",
    d: "M363.413,136c-.839-4.227-1.424-7.122-1.416-7.092,0,0,7.97-3.1,7.421-14.236-.273-5.537-2.385-14.265-4.344-21.351-1.763-6.378-7.709-13.41-14.007-11.377l-19.043,9.3c-1.913.617-2.248,2.414-1.8,4.373l.031.955,7.41,30.658,3.13,13.7a11.575,11.575,0,0,0,12.921,8.78h0A11.576,11.576,0,0,0,363.413,136Z",
    fill: "#ffbe9d"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2956",
    "data-name": "Group 2956"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2947",
    "data-name": "Group 2947"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2946",
    "data-name": "Group 2946"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2945",
    "data-name": "Group 2945"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2944",
    "data-name": "Group 2944"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2943",
    "data-name": "Group 2943"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2942",
    "data-name": "Group 2942"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2941",
    "data-name": "Group 2941"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1734",
    "data-name": "Path 1734",
    d: "M364.948,100.723a1.411,1.411,0,0,1-1.04,1.673,1.35,1.35,0,0,1-1.686-.946,1.414,1.414,0,0,1,1.038-1.675A1.353,1.353,0,0,1,364.948,100.723Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2955",
    "data-name": "Group 2955"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2954",
    "data-name": "Group 2954"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2953",
    "data-name": "Group 2953"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2952",
    "data-name": "Group 2952"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2951",
    "data-name": "Group 2951"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2950",
    "data-name": "Group 2950"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2949",
    "data-name": "Group 2949"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2948",
    "data-name": "Group 2948"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1735",
    "data-name": "Path 1735",
    d: "M364.127,98.594c-.134.216-1.343-.339-2.829-.023-1.489.294-2.42,1.288-2.619,1.14-.1-.064.01-.426.413-.872a3.869,3.869,0,0,1,2.05-1.135,3.72,3.72,0,0,1,2.3.243C363.971,98.2,364.194,98.5,364.127,98.594Z",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2972",
    "data-name": "Group 2972"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2963",
    "data-name": "Group 2963"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2962",
    "data-name": "Group 2962"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2961",
    "data-name": "Group 2961"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2960",
    "data-name": "Group 2960"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2959",
    "data-name": "Group 2959"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2958",
    "data-name": "Group 2958"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2957",
    "data-name": "Group 2957"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1736",
    "data-name": "Path 1736",
    d: "M350.478,104.04a1.412,1.412,0,0,1-1.04,1.674,1.35,1.35,0,0,1-1.685-.947,1.412,1.412,0,0,1,1.038-1.674A1.351,1.351,0,0,1,350.478,104.04Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2971",
    "data-name": "Group 2971"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2970",
    "data-name": "Group 2970"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2969",
    "data-name": "Group 2969"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2968",
    "data-name": "Group 2968"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2967",
    "data-name": "Group 2967"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2966",
    "data-name": "Group 2966"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2965",
    "data-name": "Group 2965"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2964",
    "data-name": "Group 2964"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1737",
    "data-name": "Path 1737",
    d: "M349.749,102.119c-.134.216-1.344-.338-2.829-.023-1.489.294-2.42,1.288-2.619,1.14-.1-.064.008-.425.413-.871a3.871,3.871,0,0,1,2.049-1.136,3.729,3.729,0,0,1,2.3.243C349.592,101.727,349.816,102.021,349.749,102.119Z",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2980",
    "data-name": "Group 2980"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2979",
    "data-name": "Group 2979"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2978",
    "data-name": "Group 2978"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2977",
    "data-name": "Group 2977"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2976",
    "data-name": "Group 2976"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2975",
    "data-name": "Group 2975"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2974",
    "data-name": "Group 2974"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2973",
    "data-name": "Group 2973"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1738",
    "data-name": "Path 1738",
    d: "M357.279,111.525a10.045,10.045,0,0,1,2.324-.943c.371-.119.715-.269.724-.542a1.97,1.97,0,0,0-.489-1.072l-1.729-2.655c-2.423-3.789-4.262-6.937-4.108-7.033s2.241,2.9,4.664,6.685q.882,1.406,1.686,2.683a2.242,2.242,0,0,1,.509,1.449.975.975,0,0,1-.508.686,2.642,2.642,0,0,1-.626.225A9.917,9.917,0,0,1,357.279,111.525Z",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2987",
    "data-name": "Group 2987"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2986",
    "data-name": "Group 2986"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2985",
    "data-name": "Group 2985"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2984",
    "data-name": "Group 2984"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2983",
    "data-name": "Group 2983"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2982",
    "data-name": "Group 2982"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2981",
    "data-name": "Group 2981"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1739",
    "data-name": "Path 1739",
    d: "M362,128.9a28,28,0,0,1-15.236-.822s5.235,6.84,15.807,3.57Z",
    fill: "#eb996e"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2997",
    "data-name": "Group 2997"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2996",
    "data-name": "Group 2996"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2995",
    "data-name": "Group 2995"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2994",
    "data-name": "Group 2994"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2993",
    "data-name": "Group 2993"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2992",
    "data-name": "Group 2992"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2991",
    "data-name": "Group 2991"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1740",
    "data-name": "Path 1740",
    d: "M350.03,100c-.1.428-1.628.418-3.371.846-1.752.394-3.116,1.086-3.395.747-.126-.163.075-.579.6-1.046a6.042,6.042,0,0,1,5.155-1.214C349.7,99.515,350.071,99.8,350.03,100Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3004",
    "data-name": "Group 3004"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3003",
    "data-name": "Group 3003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3002",
    "data-name": "Group 3002"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3001",
    "data-name": "Group 3001"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3000",
    "data-name": "Group 3000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2999",
    "data-name": "Group 2999"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2998",
    "data-name": "Group 2998"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1741",
    "data-name": "Path 1741",
    d: "M363.562,93.865c-.238.4-1.523.306-2.984.6-1.469.246-2.643.791-3,.5-.16-.145-.037-.524.436-.957a4.787,4.787,0,0,1,2.3-1.061,4.729,4.729,0,0,1,2.518.18C363.422,93.36,363.664,93.672,363.562,93.865Z",
    fill: "#263238"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3009",
    "data-name": "Group 3009"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1742",
    "data-name": "Path 1742",
    d: "M336.708,84.078a7.532,7.532,0,0,0,10.212,5.477c1.584-.643,3.216-1.85,4.824-1.268,1.69.612,2.221,2.859,3.79,3.737,2.242,1.255,4.943-.919,7.5-.7,1.977.166,3.51,1.705,5.058,2.946s3.7,2.281,5.446,1.341a22.309,22.309,0,0,0-1.77-4.816,7.5,7.5,0,0,0-3.663-3.464,28.141,28.141,0,0,1-2.67-.892c-1.8-.928-2.614-3.026-3.93-4.571a8.256,8.256,0,0,0-7.005-2.807c-2.165.223-4.218,1.313-6.393,1.22-1.608-.068-3.148-.783-4.757-.756-3.133.053-5.487,2.8-7.225,5.4",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1743",
    "data-name": "Path 1743",
    d: "M347.246,86.367c-1.432-.107-4.378-.408-5.346-1.43a8.437,8.437,0,0,0-8.042-2.638,6.962,6.962,0,0,0-5.019,6.662,10.008,10.008,0,0,0-7.3,7.171,11.6,11.6,0,0,0,2.5,10.5,20.79,20.79,0,0,1,1.641,2.377,17,17,0,0,0-1.779,2.7c-2.285,5.059,3.918,7,3.918,7,.017,3.4,3.151,3.385,5.162,3.375,1.934-.009,3.124,5.352,4.689,5.144l-1.59-16.562a2.069,2.069,0,0,0,.733.133c3.792.067,2.8-7.1,1.574-8.959a21.484,21.484,0,0,0,2.842-4.575,15.5,15.5,0,0,0,.147-7.667C342.7,89.4,347.875,86.413,347.246,86.367Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3033",
    "data-name": "Group 3033"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3021",
    "data-name": "Group 3021"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3020",
    "data-name": "Group 3020"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3019",
    "data-name": "Group 3019"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3018",
    "data-name": "Group 3018"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3017",
    "data-name": "Group 3017"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3016",
    "data-name": "Group 3016"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3015",
    "data-name": "Group 3015"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3014",
    "data-name": "Group 3014"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3013",
    "data-name": "Group 3013"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3012",
    "data-name": "Group 3012"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1744",
    "data-name": "Path 1744",
    d: "M336.644,111.542a3.21,3.21,0,0,0-5.155-1.72c-.96.857-1.532,2.3-.927,4.713,1.615,6.437,7.745,3.488,7.71,3.3C338.25,117.72,337.336,114.2,336.644,111.542Z",
    fill: "#ffbe9d"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3032",
    "data-name": "Group 3032"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3031",
    "data-name": "Group 3031"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3030",
    "data-name": "Group 3030"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3029",
    "data-name": "Group 3029"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3028",
    "data-name": "Group 3028"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3027",
    "data-name": "Group 3027"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3026",
    "data-name": "Group 3026"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3025",
    "data-name": "Group 3025"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3024",
    "data-name": "Group 3024"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3023",
    "data-name": "Group 3023"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3022",
    "data-name": "Group 3022"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1745",
    "data-name": "Path 1745",
    d: "M335.694,115.89c-.034-.013-.093.107-.261.241a1.156,1.156,0,0,1-.834.228c-.742-.079-1.586-1.015-1.908-2.168a3.832,3.832,0,0,1-.089-1.684,1.336,1.336,0,0,1,.628-1.072.589.589,0,0,1,.739.141c.131.158.123.3.159.3s.112-.143-.007-.4a.741.741,0,0,0-.354-.34.877.877,0,0,0-.662-.008,1.627,1.627,0,0,0-.921,1.292,3.941,3.941,0,0,0,.061,1.892c.367,1.286,1.336,2.334,2.334,2.369a1.233,1.233,0,0,0,.982-.427C335.721,116.049,335.719,115.9,335.694,115.89Z",
    fill: "#eb996e"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3035",
    "data-name": "Group 3035"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1746",
    "data-name": "Path 1746",
    d: "M371.174,102.55c-.04-.049.582-.449,1.4-1.454a9.463,9.463,0,0,0,2.01-5,9.207,9.207,0,0,0-.359-3.708,7.959,7.959,0,0,0-2.286-3.553,9.4,9.4,0,0,0-9.192-1.789c-.3.1-.58.247-.865.365-.273.143-.531.3-.786.447l-.4.223-.006-.441a3.249,3.249,0,0,0-.809-2.1,5.166,5.166,0,0,0-1.847-1.32,6.816,6.816,0,0,0-4.293-.314c-2.76.626-5.1,1.888-7.312,2.142a7.071,7.071,0,0,1-4.988-1,4.07,4.07,0,0,1-.978-1,1.754,1.754,0,0,1-.222-.433,5.741,5.741,0,0,0,1.31,1.273,7.043,7.043,0,0,0,4.83.81,17.343,17.343,0,0,0,3.358-.969,30.312,30.312,0,0,1,3.9-1.279,8.662,8.662,0,0,1,2.26-.226,6.968,6.968,0,0,1,2.33.536,5.659,5.659,0,0,1,2.038,1.448,3.765,3.765,0,0,1,.938,2.437l-.4-.218c.272-.155.547-.326.839-.479.3-.126.6-.286.921-.389a9.827,9.827,0,0,1,9.69,1.923,8.345,8.345,0,0,1,2.377,3.782,9.463,9.463,0,0,1,.312,3.876,9.35,9.35,0,0,1-2.221,5.091,6.676,6.676,0,0,1-1.115,1.034A2,2,0,0,1,371.174,102.55Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3036",
    "data-name": "Group 3036"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1747",
    "data-name": "Path 1747",
    d: "M369.865,79.944a7.132,7.132,0,0,0-2.071-.711,5.458,5.458,0,0,0-2.462.223A4.859,4.859,0,0,0,362.8,81.3l-.245.354-.15-.4a7.523,7.523,0,0,0-6.1-4.53,9.715,9.715,0,0,0-5.864,1.695,25.987,25.987,0,0,1-4.648,2.4,7.311,7.311,0,0,1-3.518.413,4.431,4.431,0,0,1-.933-.256c-.2-.088-.306-.142-.3-.159.016-.047.446.133,1.257.214a7.641,7.641,0,0,0,3.369-.559A28.09,28.09,0,0,0,350.2,78a15.918,15.918,0,0,1,2.8-1.368,7.632,7.632,0,0,1,3.359-.43,7.889,7.889,0,0,1,6.465,4.887l-.395-.047a5.171,5.171,0,0,1,2.8-1.94,5.525,5.525,0,0,1,2.613-.13,4.688,4.688,0,0,1,1.567.6C369.727,79.788,369.878,79.928,369.865,79.944Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1748",
    "data-name": "Path 1748",
    d: "M356.7,114.481a2.178,2.178,0,0,0-1.757-.51,2.573,2.573,0,0,0-1.685,1.23c-.009.012-.017.025-.026.038s-.041.053-.055.082l.024-.017a1.234,1.234,0,0,0-.188.755,1.815,1.815,0,0,0,1.045,1.352,2.3,2.3,0,0,0,2.62-.379A1.876,1.876,0,0,0,356.7,114.481Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3037",
    "data-name": "Group 3037"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1749",
    "data-name": "Path 1749",
    d: "M357.2,117.591c-.077.015-.175-.3-.441-.715a3.136,3.136,0,0,0-3.246-1.477c-.491.075-.79.206-.83.138s.209-.311.741-.5a2.959,2.959,0,0,1,3.662,1.666C357.3,117.23,357.265,117.584,357.2,117.591Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3038",
    "data-name": "Group 3038"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1750",
    "data-name": "Path 1750",
    d: "M336.792,118.828c.048-.031.286.5-.089,1.258a2.038,2.038,0,0,1-1.066.964,2.069,2.069,0,0,1-2.715-1.71,2.038,2.038,0,0,1,.408-1.378c.522-.665,1.1-.681,1.1-.623.034.078-.439.227-.791.829a1.8,1.8,0,0,0-.237,1.121,1.668,1.668,0,0,0,2.078,1.308,1.8,1.8,0,0,0,.909-.7C336.776,119.322,336.706,118.831,336.792,118.828Z",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3039",
    "data-name": "Group 3039"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1751",
    "data-name": "Path 1751",
    d: "M333.415,118.443c.057.026-.03.341-.465.553a1.262,1.262,0,0,1-.831.082,1.332,1.332,0,0,1-.915-1.691,1.263,1.263,0,0,1,.523-.651c.416-.248.727-.148.718-.087.005.078-.246.13-.494.379a.951.951,0,0,0,.877,1.621C333.173,118.577,333.353,118.4,333.415,118.443Z",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3049",
    "data-name": "Group 3049"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1752",
    "data-name": "Path 1752",
    d: "M344.413,207.254s24.759,1.436,39.394,1.571c11.336.1,16.388-2.907,18.655-10.19,1.9-6.115-2.186-17.842-2.186-17.842-7.665.039-12.4,1.1-17.329,3.407l1.315,5.362L344.342,193Z",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3041",
    "data-name": "Group 3041"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1753",
    "data-name": "Path 1753",
    d: "M392.584,195.283a14.437,14.437,0,0,0-8.556-5.833,3.53,3.53,0,0,1,1.588.138,10.594,10.594,0,0,1,6.259,4.267A3.548,3.548,0,0,1,392.584,195.283Z",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3048",
    "data-name": "Group 3048"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1754",
    "data-name": "Path 1754",
    d: "M335.347,184.164h0s-7.659,1.837-13.282,5.6l5.98,16.264c2,5.337,8.118,7.96,12.965,5.191,7.53-4.3,10.186-16.864,10.186-16.864l8.276-35.878-13.71-8.591-10.415,34.281",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3047",
    "data-name": "Group 3047"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1755",
    "data-name": "Path 1755",
    d: "M345.762,149.883l.554-11.8-3.062-11.951c-.17-.663-.253-1.488.283-1.891a1.454,1.454,0,0,1,1.848.058c.838.857,4.836,11.354,4.836,11.354s6.067-3.647,7.15-3.824,2.433,3.087,2.517,3.345a19.02,19.02,0,0,1,.011,2.193s3.752.112,4.088.627a12.885,12.885,0,0,1,.433,3.183s1.586.509,1.842,1.712.767,3.182.019,3.616-2.328,1.3-2.328,1.3-.636,6.122-.8,6.679-3.681,3.986-3.681,3.986Z",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3042",
    "data-name": "Group 3042"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1756",
    "data-name": "Path 1756",
    d: "M333.011,211.462c.016-.033.373.213,1.149.465a7.823,7.823,0,0,0,3.535.28,9.861,9.861,0,0,0,5.118-2.36,23.727,23.727,0,0,0,4.758-6.024,27.042,27.042,0,0,0,1.853-4.132,42.338,42.338,0,0,0,1.283-4.793c.785-3.37,1.631-7,2.529-10.854,1.8-7.714,3.823-16.338,6-25.627l.016-.069.052-.051c.688-.675,1.38-1.37,2.065-2.084.341-.358.683-.721,1.009-1.094a7.026,7.026,0,0,0,.454-.565c.117-.12.121-.362.167-.617.271-2,.482-4.071.7-6.154l.014-.132.117-.066,1.906-1.068c.145-.086.359-.191.449-.263a.553.553,0,0,0,.18-.335,3.193,3.193,0,0,0,.012-1.036,15.555,15.555,0,0,0-.444-2.174,2.676,2.676,0,0,0-1.592-1.284l-.173-.064-.007-.174c-.025-.579-.064-1.175-.129-1.768-.034-.3-.072-.6-.133-.878a1.722,1.722,0,0,0-.115-.371c-.031-.065-.017-.016-.062-.058a1,1,0,0,0-.168-.071,17.653,17.653,0,0,0-3.662-.413l-.261-.013.008-.257c.019-.617.045-1.306.017-1.954a2.057,2.057,0,0,0-.233-.67c-.107-.241-.223-.479-.343-.713a8.581,8.581,0,0,0-.818-1.321,2.209,2.209,0,0,0-.508-.5.486.486,0,0,0-.532-.061,12.961,12.961,0,0,0-1.41.646c-1.867.971-3.679,2.032-5.458,3.088l-.261.155-.111-.281q-1.419-3.552-2.8-7.011l-1.37-3.431a1.423,1.423,0,0,0-1.1-1.029,1.113,1.113,0,0,0-1.3.478,1.164,1.164,0,0,0-.152.712c.029.223.139.56.2.833q.228.865.453,1.723.45,1.715.893,3.4l1.733,6.6.009.035,0,.036c-.2,4.106-.39,8.046-.571,11.8l0,.027-.008.026c-3.778,12.3-6.913,22.5-9.11,29.644-1.1,3.543-1.971,6.328-2.57,8.252q-.447,1.4-.692,2.164c-.16.488-.258.735-.258.735s.055-.26.194-.755q.224-.772.63-2.182l2.458-8.286c2.154-7.162,5.228-17.379,8.934-29.7l-.009.052c.17-3.752.349-7.693.535-11.8l.007.07q-.855-3.231-1.748-6.6-.445-1.683-.9-3.4-.227-.856-.456-1.721c-.071-.306-.162-.537-.219-.907a1.673,1.673,0,0,1,.216-1.018,1.547,1.547,0,0,1,.81-.681,1.929,1.929,0,0,1,1.034-.033,2.049,2.049,0,0,1,.916.467,2.022,2.022,0,0,1,.539.862q.681,1.7,1.374,3.43,1.385,3.456,2.807,7.01l-.373-.126c1.787-1.063,3.6-2.123,5.487-3.108a13.278,13.278,0,0,1,1.484-.677,1.135,1.135,0,0,1,.5-.071,1.091,1.091,0,0,1,.474.189,2.719,2.719,0,0,1,.633.612,9.062,9.062,0,0,1,.873,1.406c.125.243.244.488.355.738a2.449,2.449,0,0,1,.278.849c.03.709,0,1.375-.016,2.008l-.253-.27a17.634,17.634,0,0,1,3.819.443,1.433,1.433,0,0,1,.258.112.642.642,0,0,1,.258.261,2.111,2.111,0,0,1,.165.507c.068.316.106.624.141.93.067.613.106,1.212.131,1.807l-.18-.237a3.161,3.161,0,0,1,1.911,1.58,15.118,15.118,0,0,1,.479,2.315,3.637,3.637,0,0,1-.024,1.215,1.063,1.063,0,0,1-.363.618,5.308,5.308,0,0,1-.51.3l-1.916,1.071.131-.2c-.225,2.089-.437,4.147-.714,6.174l-.064.388a1,1,0,0,1-.185.436,6.814,6.814,0,0,1-.493.614c-.336.383-.681.749-1.026,1.109-.692.719-1.387,1.414-2.081,2.093l.068-.12-6.069,25.61c-.916,3.851-1.778,7.475-2.579,10.841a42.3,42.3,0,0,1-1.322,4.823,27.317,27.317,0,0,1-1.9,4.169,23.738,23.738,0,0,1-4.868,6.052,9.947,9.947,0,0,1-5.254,2.344,7.7,7.7,0,0,1-3.583-.362,5.289,5.289,0,0,1-.85-.385A1.75,1.75,0,0,1,333.011,211.462Z",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3043",
    "data-name": "Group 3043"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1757",
    "data-name": "Path 1757",
    d: "M359.9,137.348c0,.074-.339.111-.867.136a10.007,10.007,0,0,0-1.992.236,3.938,3.938,0,0,0-1.7.907c-.366.341-.525.631-.6.6s-.019-.383.324-.844a3.365,3.365,0,0,1,1.841-1.166,5.813,5.813,0,0,1,2.137-.1C359.581,137.186,359.9,137.278,359.9,137.348Z",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3044",
    "data-name": "Group 3044"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1758",
    "data-name": "Path 1758",
    d: "M356.964,137.458c-.134-.051-.143-.36-.019-.69s.333-.558.468-.508.143.36.019.69S357.1,137.508,356.964,137.458Z",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3045",
    "data-name": "Group 3045"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1759",
    "data-name": "Path 1759",
    d: "M364.584,141.089a9.388,9.388,0,0,1-2.968.411,2.028,2.028,0,0,0-1.652.795c-.264.408-.176.748-.252.769-.048.046-.319-.337-.077-.935a1.633,1.633,0,0,1,.715-.794,3.171,3.171,0,0,1,1.2-.352A8.445,8.445,0,0,1,364.584,141.089Z",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3046",
    "data-name": "Group 3046"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1760",
    "data-name": "Path 1760",
    d: "M363.917,144.687c.144.006.227.745.186,1.651s-.19,1.634-.334,1.628-.227-.746-.186-1.652S363.773,144.68,363.917,144.687Z",
    fill: "#eb996e"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3051",
    "data-name": "Group 3051"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1761",
    "data-name": "Path 1761",
    d: "M368.074,171.621l.889-3.066a.837.837,0,0,1,1.4-.353l1.16,1.184.725-2.883a.837.837,0,0,1,1.567-.158l1.637,3.414Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3050",
    "data-name": "Group 3050"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1762",
    "data-name": "Path 1762",
    d: "M375.47,171.071a26.439,26.439,0,0,1-7.189,1.78,26.438,26.438,0,0,1,7.189-1.78Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3052",
    "data-name": "Group 3052"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1763",
    "data-name": "Path 1763",
    d: "M316,153.977c.024.02-.372.384-.889,1.188a10.167,10.167,0,0,0-1.356,3.776,27.285,27.285,0,0,0-.18,5.991c.11,2.264.293,4.749.57,7.349a128.983,128.983,0,0,0,2.11,13.22c.356,1.677.676,3.027.9,3.96l.257,1.074c.057.246.076.378.076.378s-.046-.125-.116-.367c-.084-.3-.182-.654-.3-1.065-.246-.927-.588-2.273-.962-3.948a117.151,117.151,0,0,1-2.174-13.23c-.277-2.6-.455-5.1-.555-7.362a26.709,26.709,0,0,1,.227-6.025,9.945,9.945,0,0,1,1.433-3.795A6.024,6.024,0,0,1,316,153.977Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3053",
    "data-name": "Group 3053"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1764",
    "data-name": "Path 1764",
    d: "M337.046,140.382a1.266,1.266,0,0,1-.225.122l-.66.315c-.572.273-1.4.675-2.391,1.224a86.188,86.188,0,0,0-7.514,4.7c-2.855,1.963-5.387,3.818-7.235,5.139l-2.2,1.554-.6.413a1.212,1.212,0,0,1-.219.132,1.18,1.18,0,0,1,.194-.166l.582-.444,2.156-1.608c1.826-1.351,4.345-3.226,7.2-5.192a75.1,75.1,0,0,1,7.563-4.654c1-.534,1.842-.917,2.427-1.168l.677-.279A1.1,1.1,0,0,1,337.046,140.382Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3054",
    "data-name": "Group 3054"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1765",
    "data-name": "Path 1765",
    d: "M384.737,146.887a.814.814,0,0,1-.167-.126l-.45-.39a17.89,17.89,0,0,0-1.752-1.307,35.587,35.587,0,0,0-6.428-3.253,65.3,65.3,0,0,0-6.855-2.281c-.891-.247-1.618-.429-2.12-.553l-.578-.147a.788.788,0,0,1-.2-.066.808.808,0,0,1,.208.025l.587.109c.508.1,1.242.26,2.14.49a55.521,55.521,0,0,1,6.894,2.23,32.615,32.615,0,0,1,6.434,3.325A12.7,12.7,0,0,1,384.737,146.887Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3055",
    "data-name": "Group 3055"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1766",
    "data-name": "Path 1766",
    d: "M337.329,223.219a1.413,1.413,0,0,1-.39-.134,6.6,6.6,0,0,1-.992-.53,4.825,4.825,0,0,1-2.175-2.945,5.765,5.765,0,0,1,.387-3.66,5.048,5.048,0,0,1,.579-.967,1.365,1.365,0,0,1,.278-.3,11.659,11.659,0,0,0-.722,1.33,5.923,5.923,0,0,0-.319,3.554,4.868,4.868,0,0,0,2.055,2.87C336.8,222.967,337.346,223.183,337.329,223.219Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3056",
    "data-name": "Group 3056"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1767",
    "data-name": "Path 1767",
    d: "M334.146,212.392a8.66,8.66,0,0,1,.752,2.57,8.66,8.66,0,0,1-.752-2.57Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3110",
    "data-name": "Group 3110"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3057",
    "data-name": "Group 3057"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1768",
    "data-name": "Path 1768",
    d: "M347.666,436.6l30.5-.153-.553-105.458-.284-107.271L336.02,223.2l-7.426,14a50.277,50.277,0,0,0-5.715,18.147c-.519,4.846,3.112,20.65,4.38,24.672l11.372,36.061Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1769",
    "data-name": "Path 1769",
    d: "M386.283,223.861,419.8,315.232a42.148,42.148,0,0,1-4.132,35.7l-38.914,75.955-21.88-27.373,32.56-68.043-28.7-46.5,4.83-61.008,13.52-.218Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3058",
    "data-name": "Group 3058"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1770",
    "data-name": "Path 1770",
    d: "M374.547,254.471s.025.159.047.469c.021.332.05.789.087,1.377.066,1.235.161,3.016.282,5.3.224,4.625.545,11.276.942,19.486.379,8.235.83,18.03,1.331,28.9.244,5.44.5,11.15.768,17.069.19,2.958.1,5.975.138,9.034q.014,4.59.028,9.306c.042,25.132.081,47.88.108,64.373-.011,8.219-.02,14.877-.027,19.507-.014,2.284-.026,4.067-.034,5.3-.009.588-.016,1.046-.021,1.379-.008.311-.026.47-.026.47s-.018-.159-.028-.47l-.029-1.379c-.015-1.237-.037-3.019-.064-5.3-.033-4.63-.081-11.287-.139-19.505-.067-16.491-.159-39.237-.26-64.365q-.014-4.713-.026-9.3c-.033-3.059.056-6.076-.131-9.034-.255-5.918-.5-11.627-.737-17.067-.458-10.874-.871-20.669-1.219-28.9-.327-8.211-.592-14.864-.776-19.491-.08-2.283-.142-4.064-.185-5.3-.015-.588-.027-1.046-.035-1.379C374.536,254.631,374.547,254.471,374.547,254.471Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3059",
    "data-name": "Group 3059"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1771",
    "data-name": "Path 1771",
    d: "M373.783,225.664a3.8,3.8,0,0,1,.211.993c.1.643.228,1.577.361,2.734.268,2.313.548,5.52.71,9.07s.168,6.771.11,9.1c-.028,1.164-.068,2.106-.113,2.755a3.792,3.792,0,0,1-.122,1.008,31.052,31.052,0,0,1-.133-3.764c-.037-2.324-.1-5.533-.263-9.074s-.382-6.742-.555-9.06A30.953,30.953,0,0,1,373.783,225.664Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3060",
    "data-name": "Group 3060"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1772",
    "data-name": "Path 1772",
    d: "M367.061,227.722a2.452,2.452,0,0,0-.676,1.14,1.3,1.3,0,0,0,.388,1.219,1.331,1.331,0,0,0,2.273-1.041,1.3,1.3,0,0,0-.67-1.09,2.434,2.434,0,0,0-1.3-.232c-.013-.027.1-.133.355-.208a1.707,1.707,0,0,1,2.1,1.505,1.79,1.79,0,0,1-3.084,1.412,1.707,1.707,0,0,1,.232-2.572C366.9,227.708,367.05,227.694,367.061,227.722Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3061",
    "data-name": "Group 3061"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1773",
    "data-name": "Path 1773",
    d: "M351.058,225.911a2.991,2.991,0,0,1,.274.957,9.482,9.482,0,0,1,.089,2.717,10.944,10.944,0,0,1-1.154,3.875,10.257,10.257,0,0,1-7.815,5.61,10.957,10.957,0,0,1-4.04-.146,9.489,9.489,0,0,1-2.547-.953,2.976,2.976,0,0,1-.819-.566,17.235,17.235,0,0,0,3.439,1.158,10.5,10.5,0,0,0,12.571-9.023A17.357,17.357,0,0,0,351.058,225.911Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3062",
    "data-name": "Group 3062"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1774",
    "data-name": "Path 1774",
    d: "M390.3,234.665a4.046,4.046,0,0,1-1.921-.227,8.927,8.927,0,0,1-6.062-6.679,4.047,4.047,0,0,1-.041-1.934c.093,0,.1.735.4,1.85a9.664,9.664,0,0,0,5.821,6.414C389.573,234.5,390.3,234.573,390.3,234.665Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3063",
    "data-name": "Group 3063"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1775",
    "data-name": "Path 1775",
    d: "M402.209,333.172a6.332,6.332,0,0,1-1.768,1.406,8.17,8.17,0,0,1-2.275.994,5.484,5.484,0,0,1-3.07-.081,8.934,8.934,0,0,1-4.273-3.4,7.928,7.928,0,0,1-1.172-1.924,12.327,12.327,0,0,1,1.462,1.7,9.478,9.478,0,0,0,4.141,3.131,6.412,6.412,0,0,0,5.005-.737A20.692,20.692,0,0,1,402.209,333.172Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3064",
    "data-name": "Group 3064"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1776",
    "data-name": "Path 1776",
    d: "M394.574,339.008a49.583,49.583,0,0,1-5.889-8.281,49.7,49.7,0,0,1,5.889,8.281Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3065",
    "data-name": "Group 3065"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1777",
    "data-name": "Path 1777",
    d: "M343.325,258.018c-.133.054-.489-.522-.8-1.286s-.445-1.426-.311-1.48.489.522.8,1.286S343.459,257.965,343.325,258.018Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3066",
    "data-name": "Group 3066"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1778",
    "data-name": "Path 1778",
    d: "M362.688,260.784c-.144,0-.261-.495-.261-1.106s.117-1.107.261-1.107.26.5.26,1.107S362.832,260.784,362.688,260.784Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3067",
    "data-name": "Group 3067"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1779",
    "data-name": "Path 1779",
    d: "M354.731,271.3c-.143.01-.3-.6-.354-1.365s.023-1.391.166-1.4.3.6.354,1.366S354.875,271.288,354.731,271.3Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3068",
    "data-name": "Group 3068"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1780",
    "data-name": "Path 1780",
    d: "M340.19,279.04c-.119.088-.531-.28-1.067-.665s-1.008-.67-.961-.81.662-.054,1.268.389S340.306,278.961,340.19,279.04Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3069",
    "data-name": "Group 3069"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1781",
    "data-name": "Path 1781",
    d: "M365.823,288.814c-.12-.08.031-.516.336-.974s.65-.765.77-.686-.031.516-.337.975S365.942,288.894,365.823,288.814Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3070",
    "data-name": "Group 3070"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1782",
    "data-name": "Path 1782",
    d: "M349.964,291.58c-.144,0-.261-.826-.261-1.844s.117-1.844.261-1.844.26.825.26,1.844S350.108,291.58,349.964,291.58Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3071",
    "data-name": "Group 3071"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1783",
    "data-name": "Path 1783",
    d: "M344.823,302.8c-.084.117-.607-.119-1.167-.526s-.946-.832-.862-.948.607.119,1.168.526S344.908,302.681,344.823,302.8Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3072",
    "data-name": "Group 3072"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1784",
    "data-name": "Path 1784",
    d: "M360.844,306.7c.058.132-.266.4-.724.607s-.878.262-.936.131.266-.4.724-.607S360.785,306.57,360.844,306.7Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3073",
    "data-name": "Group 3073"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1785",
    "data-name": "Path 1785",
    d: "M349.964,324.958c-.129.064-.646-.71-1.155-1.728s-.818-1.9-.689-1.961.645.709,1.155,1.728S350.092,324.893,349.964,324.958Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3074",
    "data-name": "Group 3074"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1786",
    "data-name": "Path 1786",
    d: "M367.667,323.3c-.127-.068.1-.742.508-1.506s.84-1.328.967-1.26-.1.741-.508,1.5S367.794,323.365,367.667,323.3Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3075",
    "data-name": "Group 3075"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1787",
    "data-name": "Path 1787",
    d: "M359.922,338.788c-.148-.022-.136-.811-.29-1.75s-.4-1.687-.264-1.754.619.641.779,1.673S360.057,338.816,359.922,338.788Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3076",
    "data-name": "Group 3076"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1788",
    "data-name": "Path 1788",
    d: "M351.623,347.639c-.106.1-.6-.278-1.114-.839s-.836-1.092-.73-1.189.606.279,1.115.839S351.73,347.543,351.623,347.639Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3077",
    "data-name": "Group 3077"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1789",
    "data-name": "Path 1789",
    d: "M371.764,351c-.1-.1.265-.64.821-1.2s1.09-.94,1.192-.839-.265.64-.821,1.2S371.866,351.1,371.764,351Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3078",
    "data-name": "Group 3078"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1790",
    "data-name": "Path 1790",
    d: "M360.18,364.247c-.142-.021-.144-.784-.005-1.7s.368-1.646.51-1.624.144.783.005,1.7S360.322,364.269,360.18,364.247Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3079",
    "data-name": "Group 3079"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1791",
    "data-name": "Path 1791",
    d: "M352.385,370.676c-.124.073-.561-.443-.976-1.151s-.65-1.342-.526-1.415.561.443.976,1.152S352.509,370.6,352.385,370.676Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3080",
    "data-name": "Group 3080"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1792",
    "data-name": "Path 1792",
    d: "M371.163,378.793c.083.117-.426.625-1.139,1.135s-1.357.829-1.441.712.426-.625,1.138-1.135S371.079,378.676,371.163,378.793Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3081",
    "data-name": "Group 3081"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1793",
    "data-name": "Path 1793",
    d: "M355.523,389.324c-.14-.05.039-.856.122-1.851s.058-1.818.2-1.844.413.817.315,1.89S355.652,389.377,355.523,389.324Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3082",
    "data-name": "Group 3082"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1794",
    "data-name": "Path 1794",
    d: "M361.766,404.436c-.113.09-.534-.25-.941-.759s-.647-.995-.535-1.085.534.251.941.76S361.878,404.347,361.766,404.436Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3083",
    "data-name": "Group 3083"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1795",
    "data-name": "Path 1795",
    d: "M354.943,414.579c-.119.081-.669-.513-1.229-1.328s-.918-1.541-.8-1.623.669.513,1.229,1.328S355.061,414.5,354.943,414.579Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3084",
    "data-name": "Group 3084"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1796",
    "data-name": "Path 1796",
    d: "M373.752,401.855c-.135-.051-.12-.422.033-.829s.386-.7.52-.646.12.421-.032.829S373.887,401.9,373.752,401.855Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3085",
    "data-name": "Group 3085"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1797",
    "data-name": "Path 1797",
    d: "M365.454,426.012c-.132-.069.119-.781.313-1.672s.276-1.64.424-1.647.3.792.084,1.76S365.574,426.081,365.454,426.012Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3086",
    "data-name": "Group 3086"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1798",
    "data-name": "Path 1798",
    d: "M370.847,271.459c-.131.061-.448-.342-.708-.9s-.367-1.058-.237-1.119.448.341.708.9S370.977,271.4,370.847,271.459Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3087",
    "data-name": "Group 3087"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1799",
    "data-name": "Path 1799",
    d: "M356.971,240.315c.079.127-.625.69-1.368,1.489s-1.266,1.532-1.4,1.462.214-.965,1.018-1.818S356.9,240.2,356.971,240.315Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3088",
    "data-name": "Group 3088"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1800",
    "data-name": "Path 1800",
    d: "M369.326,239.946c-.144.03-.38-.564-.727-1.25s-.674-1.233-.563-1.331.652.34,1.029,1.1S369.464,239.923,369.326,239.946Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3089",
    "data-name": "Group 3089"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1801",
    "data-name": "Path 1801",
    d: "M330.833,250.107c-.134-.052,0-.716.3-1.481s.656-1.342.79-1.289,0,.716-.306,1.481S330.966,250.16,330.833,250.107Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3090",
    "data-name": "Group 3090"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1802",
    "data-name": "Path 1802",
    d: "M332.076,265.21c-.092.11-.662-.213-1.273-.722s-1.032-1.012-.94-1.122.662.213,1.274.722S332.168,265.1,332.076,265.21Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3091",
    "data-name": "Group 3091"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1803",
    "data-name": "Path 1803",
    d: "M357.34,228.329c-.134.053-.407-.316-.611-.825s-.26-.966-.127-1.019.407.316.611.825S357.473,228.275,357.34,228.329Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3092",
    "data-name": "Group 3092"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1804",
    "data-name": "Path 1804",
    d: "M381.528,235.712c-.14-.031-.127-.633.029-1.345s.4-1.265.536-1.234.128.633-.028,1.345S381.669,235.743,381.528,235.712Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3093",
    "data-name": "Group 3093"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1805",
    "data-name": "Path 1805",
    d: "M387.214,247.138c-.133-.055.048-.8.4-1.666s.754-1.523.887-1.469-.049.8-.4,1.667S387.347,247.193,387.214,247.138Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3094",
    "data-name": "Group 3094"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1806",
    "data-name": "Path 1806",
    d: "M383.157,256.359c-.129.064-.605-.627-1.063-1.544s-.725-1.711-.6-1.776.6.627,1.063,1.543S383.285,256.294,383.157,256.359Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3095",
    "data-name": "Group 3095"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1807",
    "data-name": "Path 1807",
    d: "M391.824,265.579c-.134-.052-.037-.63.218-1.292s.57-1.157.7-1.1.037.629-.218,1.292S391.958,265.63,391.824,265.579Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3096",
    "data-name": "Group 3096"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1808",
    "data-name": "Path 1808",
    d: "M384.079,274.615c-.122.076-.427-.193-.682-.6s-.362-.8-.24-.876.427.193.682.6S384.2,274.539,384.079,274.615Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3097",
    "data-name": "Group 3097"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1809",
    "data-name": "Path 1809",
    d: "M385.732,293.246c-.106.1-.728-.4-1.39-1.114s-1.113-1.37-1.008-1.468.728.4,1.39,1.114S385.837,293.148,385.732,293.246Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3098",
    "data-name": "Group 3098"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1810",
    "data-name": "Path 1810",
    d: "M395.881,282.544c-.113.089-.659-.417-1.219-1.13s-.923-1.363-.81-1.452.659.417,1.219,1.131S395.994,282.455,395.881,282.544Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3099",
    "data-name": "Group 3099"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1811",
    "data-name": "Path 1811",
    d: "M401.449,297.314c-.13-.062.1-.813.507-1.677s.847-1.516.977-1.454-.1.812-.507,1.677S401.579,297.375,401.449,297.314Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3100",
    "data-name": "Group 3100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1812",
    "data-name": "Path 1812",
    d: "M389.611,309.467c-.127.077-.591-.478-1.235-1.067s-1.229-1.013-1.162-1.145.813.112,1.515.763S389.733,309.4,389.611,309.467Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3101",
    "data-name": "Group 3101"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1813",
    "data-name": "Path 1813",
    d: "M390.349,322.007c0,.144-.5.26-1.107.26s-1.106-.116-1.106-.26.5-.26,1.106-.26S390.349,321.863,390.349,322.007Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3102",
    "data-name": "Group 3102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1814",
    "data-name": "Path 1814",
    d: "M402.519,318.5c-.126-.078.131-.7.323-1.487s.267-1.454.415-1.463.311.715.09,1.59S402.634,318.582,402.519,318.5Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3103",
    "data-name": "Group 3103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1815",
    "data-name": "Path 1815",
    d: "M414.611,322.708c-.136.047-.505-.653-.825-1.565s-.469-1.689-.333-1.736.505.652.825,1.564S414.747,322.66,414.611,322.708Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3104",
    "data-name": "Group 3104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1816",
    "data-name": "Path 1816",
    d: "M412.685,339.906c-.128-.066.18-.906.688-1.874s1.022-1.7,1.15-1.633-.181.906-.689,1.875S412.812,339.973,412.685,339.906Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3105",
    "data-name": "Group 3105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1817",
    "data-name": "Path 1817",
    d: "M401.649,350.015c-.133.055-.543-.638-.917-1.547s-.569-1.692-.435-1.747.543.639.917,1.549S401.782,349.961,401.649,350.015Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3106",
    "data-name": "Group 3106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1818",
    "data-name": "Path 1818",
    d: "M389.427,353.909c0,.144-.413.261-.922.261s-.922-.117-.922-.261.412-.26.922-.26S389.427,353.765,389.427,353.909Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3107",
    "data-name": "Group 3107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1819",
    "data-name": "Path 1819",
    d: "M396.434,369.952c-.139.038-.417-.552-.62-1.315s-.257-1.413-.118-1.451.417.552.621,1.317S396.573,369.916,396.434,369.952Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3108",
    "data-name": "Group 3108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1820",
    "data-name": "Path 1820",
    d: "M387.583,364.605c-.124-.074.024-.547.329-1.056s.654-.862.777-.788-.024.546-.33,1.056S387.706,364.679,387.583,364.605Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3109",
    "data-name": "Group 3109"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1821",
    "data-name": "Path 1821",
    d: "M387.4,382.308c-.143.017-.341-.672-.443-1.537s-.068-1.581.074-1.6.341.671.443,1.537S387.541,382.291,387.4,382.308Z",
    fill: "#fafafa"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyus);
export default __webpack_public_path__ + "static/media/whyus.18a6d0a99918c1a93aa977e9bb102cad.svg";
export { ForwardRef as ReactComponent };